var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"intake-address",attrs:{"type":"button","title":_vm.$t('Copy address')},on:{"click":_vm.copy}},[_c('span',{staticClass:"intake-address__value"},[_vm._v(_vm._s(_vm.address))]),_c('i',{staticClass:"intake-address__icon",class:[_vm.copied ? 'el-icon-check' : 'el-icon-document-copy', { 'is-copied': _vm.copied }]})])
}
var staticRenderFns = []

export { render, staticRenderFns }